import { get } from './client'

export interface GroupInfo {
  desc?: string
  ratio?: number
  group_ratio?: number
  name?: string
}

/**
 * 获取所有分组
 * GET /api/group
 */
export async function getGroupsApi(): Promise<string[]> {
  const groups = await get<unknown>('/api/group')
  if (!Array.isArray(groups)) return []
  return Array.from(new Set(groups.map((group) => String(group).trim()).filter(Boolean))).sort((a, b) =>
    a.localeCompare(b)
  )
}

/**
 * 获取用户可用分组
 * GET /api/user/self/groups
 */
export async function getUserSelfGroupsApi(): Promise<Record<string, GroupInfo>> {
  return get<Record<string, GroupInfo>>('/api/user/self/groups')
}

/**
 * 获取所有公开分组
 * GET /api/user/groups
 */
export async function getUserGroupsPublicApi(): Promise<Record<string, GroupInfo>> {
  return get<Record<string, GroupInfo>>('/api/user/groups')
}
